/**
 * LEGACY (2026-10-14): downloads page of the deprecated old ABM report. Mounted
 * only on the Bluewhale white label (VITE_APP=BLUEWHALERESEARCH); other brands
 * redirect `/dashboard/downloads` to the new ABM (see main.routes.tsx).
 */
import routes from "@/routes";
import { lazy } from "react";

const ReportsCampaignSummaryAbm = lazy(
  () => import("@/modules/Report/Abm/ReportsCampaignSummaryAbm")
);
const ReportsCampaignSummaryRoutes = {
  element: <ReportsCampaignSummaryAbm />,
  path: routes.REPORTS.ABM.REPORTS,
};

export default ReportsCampaignSummaryRoutes;
